import SectionPromotedListings from './SectionPromotedListings';

export default SectionPromotedListings;
